export default __webpack_public_path__ + "static/media/get-started.a782dfa7.png";